export default async function () {
  if (document.querySelectorAll('.lazyload').length) {
    const nativeLazy = false;
    if ('loading' in HTMLImageElement.prototype && nativeLazy) {
      const images: HTMLImageElement[] = [
        ...document.querySelectorAll<HTMLImageElement>('img[loading="lazy"]'),
      ];
      images.forEach((img: HTMLImageElement) => {
        img.src = img.dataset.src ?? img.src ?? '';
        img.srcset = img.dataset.srcset ?? '';
        img.sizes = `${img.getBoundingClientRect().width}px`;
      });
    } else {
      const LazySizes = await import(/* webpackChunkName: "LazySizes" */ 'lazysizes');

      // fix issue when image is already in viewport and content is not loaded yet
      document.addEventListener('DOMContentLoaded', () => {
        LazySizes.init();
      });

      document.addEventListener('lazyloaded', (e) => {
        const target = e.target as HTMLElement;
        if (target) {
          const parentNode: HTMLElement | null = target.parentElement;
          if (parentNode?.style?.backgroundColor) {
            setTimeout(() => {
              // target.style.backgroundColor = 'transparent';
            }, 1000);
          }
        }
      });
    }
  }
}
